<template>
	<div class="tasks" v-if="weekView === 'byPlanning'">
		<div
			class="tasks__section tasks__section--planning"
			v-for="planning in plannings"
			:key="planning.id">
			<div class="tasks__section__header tasks__section__header--planning">
				<router-link
					:to="`/planning/${planning.id}`"
					tag="div"
					class="tasks__section__header__title tasks__section__header__title--planning clickable">
					<Icon
						:size="$mq === 'lg' ? 100 : 50"
						:icon="planning.Info.icon">
					</Icon>
					{{planning.Info.title}}
				</router-link>
			</div>
			<div class="tasks__section__content tasks__section__content--planning">
				<div class="tasks__section__content__wrapper">
					<Task
						v-for="(task) in getTasks(week, planning.Tasks, planning.id)"
						:task="task"
						:key="task.id"
						:id="task.id"
						:topic="planning.Topics[task.topicIndex]"
						:pageIsWeek="true">
					</Task>
				</div>
			</div>
		</div>
	</div>
	<div class="tasks" v-else-if="weekView === 'byDay'">
		<template
			v-for="(day, dayIndex) in getDaysOfWeek(week.date, ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'])">
			<div v-if="tasksByDay[dayIndex].plannings.length > 0" class="tasks__day" :key="day.date">
				<p class="tasks__day__header">
					{{new Date(day).format('l').toUpperCase()}}
				</p>
				<div
					class="tasks__section tasks__section--planning"
					v-for="(planning, planningIndex) in tasksByDay[dayIndex].plannings"
					:key="dayIndex + ' ' + planningIndex">
					<div class="tasks__section__header tasks__section__header--planning">
						<router-link
							:to="`/planning/${planning.id}`"
							tag="div"
							class="tasks__section__header__title tasks__section__header__title--planning clickable">
							<Icon
								:size="$mq === 'lg' ? null : 60"
								:icon="planning.Info.icon">
							</Icon>
							<span>{{planning.Info.title}}</span>
						</router-link>
					</div>
					<div class="tasks__section__content tasks__section__content--planning">
						<div class="tasks__section__content__wrapper">
							<Task
								v-for="(task, taskIndex) in tasksByDay[dayIndex].plannings[planningIndex].tasks"
								:task="task"
								:key="taskIndex"
								:topic="task.topic"
								:pageIsWeek="true">
							</Task>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import DateService from '@/services/DateService'
import PlanningService from '@/services/PlanningService'
import Icon from '@/components/Icon'
import { tasks } from '@/components/mixins/tasks'
export default {
	components: {
		Icon
	},
	mixins: [tasks],
	props: {
		plannings: Array,
		week: Object
	},
	data () {
		return {
		}
	},
	methods: {
		getDayTasks (day, tasks) {
			var dayTasks = PlanningService.getDayTasks(day, tasks)
			return dayTasks.sort(function (a, b) {
				return a.planningId - b.planningId
			})
		},
		getTaskDays (tasks) {
			return DateService.getTaskDays(tasks)
		},
		getTasks (week, tasks, planningId) {
			tasks = this.getWeekTasks(week, tasks)
			tasks.forEach(task => { task.planningId = planningId })
			return tasks
		}
	},
	computed: {
		weekView () {
			return this.$store.state.settings.weekView
		},
		tasksByDay () {
			var tasksByDay = []
			const target = this
			this.getDaysOfWeek(this.week.date, ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']).forEach(function (day, index) {
				tasksByDay[index] = { date: day, plannings: [] }
				target.plannings.forEach(function (planning) {
					planning.Tasks.forEach(function (task) {
						task.planningId = planning.id
						task.topic = planning.Topics[task.topicIndex]
						task.owner = planning.User.id
					})
					const planningDayTasks = target.getDayTasks(day, planning.Tasks)
					if (planningDayTasks.length > 0) {
						tasksByDay[index].plannings.push({
							id: planning.id,
							Info: { icon: planning.Info.icon, title: planning.Info.title },
							tasks: planningDayTasks
						})
					}
				})
			})
			return tasksByDay
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/styles/components/_tasks.scss"
</style>
